var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileNav = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#828282"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#828282"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#828282"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileNav);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile_nav.d3be1a98e47aaa69bdfa547b3e6e4f61.svg";